
/*import {DoccliService} from '../../../providers/DoccliService.js';
const doccliService = new DoccliService();*/
export default {
  data () {
  return {
    initOk:false,
    eligibilite:null,
    id_eligibilite: null,
    service:null,
    offre:null,
    options:[],
    tabs: null,
    text: 'chargement en cours...',    
    loading:false,
    docType:"IDENT",
    piecesToScan:['IDENT_PRIN'],
    pieceId:true,
    pieceJustifDom: true,
    pieceIban: true,
    adrTech: null,
    showJustifDom:false

  }
},
mounted: function () {
  this.init();
},

  methods: {
    
    scanDocument: function(){
      

      if(this.pieceIban && this.pieceJustifDom){
        this.docType = 'IDENT_IBAN_JUSTIF';
      }else if(this.pieceIban){
        this.docType = 'IDENT_IBAN';
      }else if(this.pieceJustifDom){
        this.docType = 'IDENT_JUSTIF';
      }else
        this.docType = 'IDENT';

      

      //initialisation des pieces
      if(this.pieceIban )
        this.piecesToScan.push('IBAN');
     

      if(this.showJustifDom){
        this.piecesToScan.push('JUSTIF_DOM');
        
      }
      /*
      alert(this.docType +'|tiers:'+this.tiers +' | heberg:'+this.hebergeur);
      if(this.pieceId)
        return false;*/
      this.loading = true;
      //const typeScan = ['ID','IBAN'];
      var optionsSelected = [];
      this.options.forEach(opt => {
        optionsSelected.push(opt.id);
       });
      this.$globalService.setSessionSouscription('piecesToScan',this.piecesToScan);
      this.$router.push({name: 'Cgv'});
      
      //this.$router.push({path: '/souscription/scandocuments'});
    },
    init: async function(){
      //suppression IBAN pour la VAD
      if(this.$root.user.type == 'VAD'){
        this.pieceIban = false;
      }
      this.$root.progress = true;
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(!sessionSouscription || !sessionSouscription.eligibilite || !sessionSouscription.serviceChoisi || !sessionSouscription.offreChoisie || !sessionSouscription.optionsChoisies){
        await this.$dialog.error({
          text: "Une erreur s'est produite",
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
        this.$root.progress = false;
        this.$router.push({name: 'ChoixCategorieOffre'});
      }

      if(sessionSouscription.adrTech) {
        this.adrTech = sessionSouscription.adrTech;
      }
      this.$root.progress = false;
      this.eligibilite = sessionSouscription.eligibilite;
      this.service = sessionSouscription.serviceChoisi;
      this.offre= sessionSouscription.offreChoisie;
      this.options = sessionSouscription.optionsChoisies
      this.initOk = true;
      //await this.$nextTick()
    }
  }
}